export default {
  logkey: '/sc.5.offer_img_info',
  selector: '[data-search-gt-img]',
  pidAttr: 'data-search-gt-img',
}
